export default __webpack_public_path__ + "static/media/favoritesLabelIcon.cc702c98.svg";